import { Button, Typography } from '@mui/material';
import { ReactNode } from 'react';
import useCustomDialogStyles from './CustomDialog.styles';

interface Props {
	body?: ReactNode;
	leftAction: string;
	onLeftAction(): void;
	onRightAction(): void;
	rightAction: string;
	title: string;
}

const CustomDialog: React.FC<Props> = ({
	body,
	leftAction,
	onLeftAction,
	onRightAction,
	rightAction,
	title,
}) => {
	const classes = useCustomDialogStyles();

	return (
		<div className={classes.root}>
			<div className={classes.bg} />
			<div className={classes.dialogContainer}>
				<Typography color="#003C82" fontFamily="Montserrat" fontSize={16} fontWeight={700}>
					{title}
				</Typography>
				{body && (
					<Typography
						color="#686868"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight={500}
						style={{ marginTop: 12 }}
					>
						{body}
					</Typography>
				)}
				<div className={classes.actions}>
					<Button
						color="inherit"
						onClick={onLeftAction}
						sx={{
							borderColor: '#0000001F',
							color: '#686868',
							paddingLeft: '24px',
							paddingRight: '24px',
						}}
						variant="outlined"
					>
						{leftAction}
					</Button>
					<Button
						color="primary"
						onClick={onRightAction}
						sx={{ paddingLeft: '24px', paddingRight: '24px' }}
						variant="contained"
					>
						{rightAction}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default CustomDialog;
